import { render } from "./RecapCancelledMenu.vue?vue&type=template&id=5d278630&ts=true"
import script from "./RecapCancelledMenu.vue?vue&type=script&lang=ts"
export * from "./RecapCancelledMenu.vue?vue&type=script&lang=ts"

import exportComponent from "/home/admindb/web/crevent.pedasabis.com/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__